var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHoverEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_513_1120)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.32801 0.465036L3.23201 6.56104C2.99918 6.79261 2.8146 7.06806 2.68895 7.37146C2.5633 7.67485 2.49908 8.00015 2.50001 8.32854V9.00004C2.50001 9.13264 2.55269 9.25982 2.64646 9.35359C2.74022 9.44736 2.8674 9.50004 3.00001 9.50004H3.67151C3.99989 9.50096 4.3252 9.43674 4.62859 9.3111C4.93198 9.18545 5.20744 9.00086 5.43901 8.76804L11.535 2.67204C11.8272 2.37912 11.9913 1.98227 11.9913 1.56854C11.9913 1.1548 11.8272 0.757951 11.535 0.465036C11.2378 0.180983 10.8426 0.0224609 10.4315 0.0224609C10.0204 0.0224609 9.62517 0.180983 9.32801 0.465036ZM10.828 1.96504L4.73201 8.06104C4.45007 8.34125 4.06901 8.49899 3.67151 8.50004H3.50001V8.32854C3.50105 7.93103 3.65879 7.54997 3.93901 7.26804L10.035 1.17204C10.1418 1.07001 10.2838 1.01308 10.4315 1.01308C10.5792 1.01308 10.7212 1.07001 10.828 1.17204C10.933 1.27729 10.9919 1.41988 10.9919 1.56854C10.9919 1.71719 10.933 1.85978 10.828 1.96504Z",
    fill: "url(#paint0_linear_513_1120)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 4.4895C11.3674 4.4895 11.2402 4.54218 11.1464 4.63595C11.0527 4.72972 11 4.85689 11 4.9895V7.5H9C8.60218 7.5 8.22064 7.65804 7.93934 7.93934C7.65804 8.22064 7.5 8.60218 7.5 9V11H2.5C2.10218 11 1.72064 10.842 1.43934 10.5607C1.15804 10.2794 1 9.89783 1 9.5V2.5C1 2.10218 1.15804 1.72064 1.43934 1.43934C1.72064 1.15804 2.10218 1 2.5 1H7.021C7.15361 1 7.28079 0.947322 7.37455 0.853554C7.46832 0.759785 7.521 0.632608 7.521 0.5C7.521 0.367392 7.46832 0.240215 7.37455 0.146447C7.28079 0.0526784 7.15361 0 7.021 0L2.5 0C1.8372 0.000793929 1.20178 0.264441 0.73311 0.73311C0.264441 1.20178 0.000793929 1.8372 0 2.5L0 9.5C0.000793929 10.1628 0.264441 10.7982 0.73311 11.2669C1.20178 11.7356 1.8372 11.9992 2.5 12H8.1715C8.49996 12.0009 8.82534 11.9367 9.12882 11.8111C9.43229 11.6854 9.70784 11.5008 9.9395 11.268L11.2675 9.939C11.5004 9.70744 11.685 9.43199 11.8108 9.1286C11.9365 8.82522 12.0008 8.49991 12 8.1715V4.9895C12 4.85689 11.9473 4.72972 11.8536 4.63595C11.7598 4.54218 11.6326 4.4895 11.5 4.4895ZM9.2325 10.561C9.03151 10.7615 8.77734 10.9003 8.5 10.961V9C8.5 8.86739 8.55268 8.74022 8.64645 8.64645C8.74022 8.55268 8.86739 8.5 9 8.5H10.9625C10.9006 8.77676 10.762 9.03047 10.5625 9.232L9.2325 10.561Z",
    fill: "url(#paint1_linear_513_1120)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_513_1120",
    x1: 7.24565,
    y1: 9.50005,
    x2: 7.24565,
    y2: 0.0224609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCAD3A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_513_1120",
    x1: 6,
    y1: 12,
    x2: 6,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCAD3A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_513_1120"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoverEditIcon);
export default __webpack_public_path__ + "static/media/hoverEditIcon.4f3ee902075fd99036c2ff393eef9e15.svg";
export { ForwardRef as ReactComponent };